import { Component, EventEmitter, HostBinding, OnDestroy, Output } from '@angular/core';
import { FADE_IN_OUT_ANIMATION } from 'src/app/shared/animations/animations';
import { ColorPipe } from 'src/app/shared/pipes/color.pipe';

const colorList = [
  0x0b0e1f, 0x6439df, 0x4761d2, 0x3e8be6, 0x078eac, 0x53cc97, 0xffb421, 0xf6531a, 0xff22b0,
  0xb5113b, 0xbf4a00, 0x1d1d39, 0x895ef6, 0x6984ed, 0x4da1f7, 0x20cbdd, 0x7ae3aa, 0xffc63b,
  0xff763e, 0xff61c7, 0xf12f63, 0xca6419, 0x494e6b, 0xaa8efe, 0x869bf4, 0x65c0f7, 0x89eaf3,
  0x8aefb7, 0xffd565, 0xfb9e78, 0xfe97d9, 0xf98298, 0xd37b3c, 0x717590, 0xd5c9fa, 0xc3cefc,
  0xa1e0f6, 0xb7f4f4, 0xb8f4da, 0xfeeab3, 0xfecfba, 0xf8cae7, 0xfca7c2, 0xeab68c,
];

@Component({
    selector: 'gl-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    animations: [FADE_IN_OUT_ANIMATION],
    standalone: false
})
export class ColorPickerComponent implements OnDestroy {
  @HostBinding('@show') public show: any;
  public colors = [];
  @Output() private closeColorPicker = new EventEmitter();
  @Output() private choosenColor = new EventEmitter();

  constructor(private colorPipe: ColorPipe) {
    this.generateColorsList(colorList);
  }

  public ngOnDestroy() {
    this.close();
  }

  public close() {
    this.closeColorPicker.emit();
  }

  public changeColor(colorIndex: number) {
    this.choosenColor.emit(colorList[colorIndex]);
  }

  private generateColorsList(colors: number[]) {
    colors.forEach((color: any) => {
      this.colors.push(this.colorPipe.transform(color));
    });
  }
}
